import React from 'react'
import SearchIcon from "@material-ui/icons/Search";
function EventsSearch({className, inputClass,onSearch,value, placeholder}) {
    return (
        <>
            <div className={`searchBarWrapper flex w-100 relative items-center rounded-3xl ${className}`}>
                <SearchIcon className="text-gray-400" />
                <input type="search" placeholder={placeholder ? placeholder : `Search...`} className={`seachInput placeholder:italic ${inputClass}`} autoComplete="off" id="mainSearchBar" value={value} onChange={onSearch}/>
            </div>
        </>
    )
}

export default EventsSearch
